import React from 'react';
import './MessageBox.css';

//
const MessageBox = (props) => {
    return <div className={`message ${props.messageState}`}>
        <span class={`${props.messageState}-icon`}></span>
        <span class={`${props.messageState}-text`}> {props.children}</span>
    </div>
}


export default MessageBox;